var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4825 5.30575L13.9307 10.074V10.5098H14.4307H18.8807C19.3616 10.5098 19.5672 11.1253 19.169 11.4137C19.1687 11.4139 19.1684 11.4141 19.1681 11.4143L15.5301 14.0129L15.2361 14.2229L15.3431 14.5679L16.7731 19.1779L16.7734 19.1786C16.9175 19.6409 16.3792 20.0174 15.9948 19.7229L15.9936 19.722L12.3036 16.912L12.0012 16.6817L11.6985 16.9115L8.00845 19.7115L8.00658 19.7129C7.62217 20.0074 7.08386 19.6309 7.22802 19.1686L7.22824 19.1679L8.65824 14.5579L8.76527 14.2129L8.47131 14.0029L4.83131 11.4029L4.82984 11.4019C4.44032 11.1257 4.63448 10.4998 5.12069 10.4998H9.57069H9.94065L10.0488 10.146L11.5288 5.30598L11.5289 5.30598L11.5303 5.30112C11.6669 4.83765 12.334 4.81944 12.4825 5.30575Z",
    stroke: "#A9ACAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/star-gray.18b26b0e3144ac34bc0d16be6380bcc0.svg";
export { ForwardRef as ReactComponent };